import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const ViewSettingsContext = createContext();

// Custom hook to use the view settings
export const useViewSettings = () => {
  const context = useContext(ViewSettingsContext);
  if (!context) {
    throw new Error('useViewSettings must be used within a ViewSettingsProvider');
  }
  return context;
};

// Fontes disponíveis
const FONT_OPTIONS = [
  { label: 'Montserrat', value: 'Montserrat, sans-serif' },
];

// Tamanhos de fonte disponíveis
const FONT_SIZE_OPTIONS = [
  { label: 'Compacto', value: '0.75rem' },
  { label: 'Confortável', value: '0.95rem' },
];

// Provider component
export const ViewSettingsProvider = ({ children }) => {
  const [showDescriptions, setShowDescriptions] = useState(true);
  const fontFamily = 'Montserrat, sans-serif';
  const [fontSize, setFontSize] = useState(() => localStorage.getItem('fontSize') || '0.75rem');
  const [themeId, setThemeId] = useState(() => localStorage.getItem('themeId') || 'escuro');

  useEffect(() => {
    localStorage.setItem('fontFamily', 'Montserrat, sans-serif');
  }, [fontFamily]);
  useEffect(() => {
    localStorage.setItem('fontSize', fontSize);
  }, [fontSize]);
  useEffect(() => {
    localStorage.setItem('themeId', themeId);
  }, [themeId]);

  const value = {
    showDescriptions,
    setShowDescriptions,
    fontFamily: 'Montserrat, sans-serif',
    setFontFamily: () => {},
    fontSize,
    setFontSize,
    themeId,
    setThemeId,
    FONT_OPTIONS,
    FONT_SIZE_OPTIONS,
  };

  return (
    <ViewSettingsContext.Provider value={value}>
      {children}
    </ViewSettingsContext.Provider>
  );
};

export default ViewSettingsContext; 
